<template>
    <v-dialog
        :id="modalId"
        lazy
        :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '50%'"
        v-model="showModal"
        v-if="feesLoaded"
    >
        <v-card class="text-xs-left">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" fab small @click.stop="showModal = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-text>
                <v-container fluid>
                    <v-layout row wrap hidden-xs-only font-weight-bold>
                        <v-flex>
                            {{ 'Shipping to' | translation }}
                        </v-flex>
                        <v-spacer />
                        <v-flex class="text-xs-right">
                            {{ 'MwSt' | translation }}
                        </v-flex>
                    </v-layout>
                    <v-layout v-for="(fee, index) in fees" :key="index" row wrap>
                        <template v-if="fee.vatRate > 0" mb-2>
                            <v-flex xs12 sm4 py-0>
                                <strong class="hidden-sm-and-up">{{ 'Shipping to' | translation }}</strong>
                                {{ $country.getCountryNameBy('iso_2', fee.country) | translation }}
                            </v-flex>
                            <v-flex xs12 sm8 py-0 :class="$vuetify.breakpoint.xsOnly ? 'text-xs-left' : 'text-xs-right'">
                                <strong class="hidden-sm-and-up">{{ 'MwSt' | translation }}</strong>
                                {{ fee.vatRate }}%
                            </v-flex>
                        </template>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { loadProducts } from '@breakmedia/prime-vue-product/src/store/getProducts';

const parentModuleName = 'Product';
const { mapState } = createNamespacedHelpers(parentModuleName);

export default {
    props: {
        modalId: String,
        merchantID: Number,
        value: Boolean,
    },
    data() {
        return {
            currency: null,
            countries: {},
            feesLoaded: false,
            fees: [],
        };
    },
    mounted() {
        this.currency = this.$currency.getSelected();
        this.countries = this.$country.getCountries();
    },
    computed: {
        ...mapState({
            currentProductId: state => state.currentProductId,
        }),
        showModal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        beforeShow() {
            const productsRequests = [];
            Object.keys(this.countries).forEach(country => {
                const priceParams = [];
                priceParams.push({
                    country: country,
                    merchant: this.merchant,
                    quantity: 1,
                    currency: this.currency,
                });
                productsRequests.push(
                    loadProducts({ ids: [this.currentProductId], fields: 'id price', priceParams: priceParams }).then(
                        products => {
                            return {
                                country: country,
                                vatRate: products[0].price.VAT,
                            };
                        },
                    ),
                );
            });
            this.fees = [];
            return Promise.all(productsRequests).then(fees => {
                this.fees = fees;
                this.feesLoaded = true;
            });
        },
    },
    watch: {
        showModal(value) {
            if (value) {
                this.beforeShow();
            } else {
                this.feesLoaded = false;
            }
        },
    },
};
</script>
